/**
 * @author       yewon@zumper.com (Yewon Lee)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  index.ts
 */

import { getLiveEnv } from '@zcode/env'

export interface BaseOptions {
  // can pass in existing setting
  settings: Iterable<any>
  frozen?: boolean
}

export class Settings {
  private readonly settings: Map<string, any>
  private frozen?: boolean

  constructor(options?: BaseOptions) {
    this.frozen = false
    if (options?.settings) {
      this.settings = new Map(options.settings)
    } else {
      this.settings = new Map()
    }
  }

  createSetting(key: string, value: any) {
    if (!this.frozen) {
      this.setSetting(key, value)
      return value
    }
  }

  setSetting(key: string, value: any) {
    if (!this.frozen) {
      this.settings.set(key, value)
    }
  }

  getSetting(key: string): unknown {
    if (this.settings.has(key)) {
      return this.settings.get(key)
    }
  }

  freeze() {
    this.frozen = true

    const shouldLog = getLiveEnv('DEBUG_SETTING')
    if (shouldLog || shouldLog === 'true') {
      for (const [key, value] of this.settings) {
        // can't use @zcode/logger due to circular dependency
        console.debug(`${key} = ${JSON.stringify(value, null, 2)}`)
      }
    }
  }
}
